// extracted by mini-css-extract-plugin
module.exports = {"guarantee_wrapper":"styles_guarantee_wrapper__qB82t","badge_wrapper":"styles_badge_wrapper___LpT2","text_wrapper":"styles_text_wrapper__cvgcB","divider":"styles_divider__yaZ3b"};